import { IAuth } from './IAuth';
import { makeAutoObservable } from 'mobx';

export class OutlookSSOAuth implements IAuth {
	private currentTokenPromise?: Promise<string>;

	//This is used when a we can't do SSO and instead, a token is passed via localstorage.
	//This happens when we launch an outlook popup dialog, because an sso token can't be generated in a dialog.
	private storedSSOToken?: string;

	constructor() {
		makeAutoObservable(this);

		setInterval(() => {
			//Reset the token every 10 seconds
			this.currentTokenPromise = undefined;
		}, 10000);
	}

	login() {
		throw new Error('invalid operation');
	}

	logout() {
		throw new Error('invalid operation');
	}

	getToken = (): Promise<string> => {
		if (!this.currentTokenPromise) {
			this.currentTokenPromise = new Promise<string>(async (resolve, reject) => {
				if (this.storedSSOToken) {
					resolve(this.storedSSOToken);
				} else {
					//If there's a token in local storage, use that
					let token = window.localStorage.getItem('helmSSO');
					if (token) {
						this.storedSSOToken = token;
						window.localStorage.removeItem('helmSSO');
						resolve(token);
					} else {
						try {
							let token = await Office.auth.getAccessToken({
								allowSignInPrompt: true,
								allowConsentPrompt: true,
								forMSGraphAccess: false,
							});
							resolve(token);
						} catch (e) {
							await new Promise((resolve) => setTimeout(resolve, 500));
							let token = await Office.auth.getAccessToken({
								allowSignInPrompt: true,
								allowConsentPrompt: true,
								forMSGraphAccess: false,
							});
							resolve(token);
						}
					}
				}
			});
		}

		return this.currentTokenPromise;
	};
}
